import {createAction, props} from '@ngrx/store';
import {Attribute} from '../models/attribute';

export const loadAttributes = createAction(
    '[Attributes] Load'
);

export const loadAttributesSuccess = createAction(
    '[Attributes] Load Success',
    props<{ attributes: Attribute[] }>()
);

export const loadAttributesFailure = createAction(
    '[Attributes] Load Failure',
    props<{ error: string }>()
);
